import { Input } from 'components'
import { useRecoilState } from 'recoil'
import { editCaseFieldSelector } from 'atoms'
import { useState, useEffect } from 'react'

export const CaseInputWrapper = ({ name, label, width, margin }) => {
  const [localValue, setLocalValue] = useState('')
  const [recoilValue, setRecoilValue] = useRecoilState(
    editCaseFieldSelector({ name: name, path: 'value' }),
  )

  useEffect(() => {
    setLocalValue(recoilValue || '')
  }, [recoilValue])

  const handleChange = (value) => {
    setLocalValue(value)
    setRecoilValue(value)
  }

  return (
    <Input
      width={width}
      margin={margin || '0 24px 0 0'}
      label={label}
      value={[localValue, handleChange]}
    />
  )
}

export default CaseInputWrapper
